import type { PrimaryKey } from '#layers/data-model/types/schema/primary-key';
import { isNil } from '#layers/base/public';

export function isEmptyKey(key?: PrimaryKey | null) {
	return isNil(key) || (typeof key === 'object' && Object.values(key).every((value) => isNil(value)));
}
